import { useEffect, useState } from "react";
import api from "@/lib/api";
import { LabelBadge } from "@/components/LabelBadge";
import { Editable, ImageBlockZone } from "@/components/Editable";
import { Trophy } from "lucide-react";

export default function Achievements() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/achievements").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6">
      <header className="text-center">
        <Editable id="achievements.title" as="h1" fallback="Achievements" className="font-serif-arc text-4xl font-black tracking-tight sm:text-5xl" />
        <Editable id="achievements.subtitle" as="p" mode="multiline" fallback="A record of milestones and accomplishments across both encyclopedias. Some are real. Some are labelled SATIRE for a reason." className="mx-auto mt-4 max-w-xl text-sm" style={{ color: "var(--arc-text-2)" }} />
      </header>

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((a) => {
          const isGhoulax = a.encyclopedia === "ghoulax";
          return (
            <article key={a.id} data-testid={`achievement-${a.id}`} className="flex flex-col rounded-md border p-6 shadow-sm" style={{ backgroundColor: "var(--arc-card)" }}>
              <div className="mb-4 flex items-center justify-between">
                <div className="flex h-10 w-10 items-center justify-center rounded-md" style={{ backgroundColor: isGhoulax ? "var(--ghoulax-soft)" : "var(--zyfley-soft)" }}>
                  <Trophy size={20} style={{ color: isGhoulax ? "var(--ghoulax)" : "var(--zyfley)" }} />
                </div>
                {a.satire && <LabelBadge label="SATIRE" />}
              </div>
              <h2 className="font-serif-arc text-lg font-bold">{a.name}</h2>
              <p className="mt-2 flex-1 text-sm leading-relaxed" style={{ color: "var(--arc-text-2)" }}>{a.description}</p>
              <dl className="mt-4 space-y-1 border-t pt-3 text-xs" style={{ color: "var(--arc-text-2)" }}>
                <div className="flex justify-between"><dt className="font-semibold">Date</dt><dd>{a.date}</dd></div>
                {a.category && <div className="flex justify-between"><dt className="font-semibold">Category</dt><dd>{a.category}</dd></div>}
                {a.source && <div className="flex justify-between"><dt className="font-semibold">Source</dt><dd>{a.source}</dd></div>}
              </dl>
            </article>
          );
        })}
      </div>
      {items.length === 0 && <p className="mt-10 text-center text-sm" style={{ color: "var(--arc-text-2)" }}>No achievements documented yet.</p>}
    </div>
  );
}
